import { Button, Menu } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconHistory } from "@tabler/icons-react";
import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import HistoryModal from "src/components/shared/_Modals/HistoryModal/HistoryModal";
import { useCheckPerm, useIsNewEntry } from "src/hooks";

interface Props {
  hamburger?: boolean;
  summary?: boolean;
}

const HistoryButton = ({ hamburger, summary }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [opened, { open, close }] = useDisclosure(
    searchParams.get("fromHistory") === "true",
  );
  const isNewEntry = useIsNewEntry();
  const checkPerm = useCheckPerm();

  useEffect(() => {
    setSearchParams(
      prev => {
        prev.delete("fromHistory");
        return prev;
      },
      { replace: true },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Component = useCallback(
    () =>
      hamburger ? (
        <Menu.Item
          disabled={isNewEntry}
          leftSection={<IconHistory size={20} />}
          onClick={open}>
          History
        </Menu.Item>
      ) : (
        <Button
          variant="outline"
          leftSection={<IconHistory size={20} />}
          onClick={open}>
          History
        </Button>
      ),
    [hamburger, isNewEntry, open],
  );

  if (!checkPerm("viewhistory")) {
    return <></>;
  }

  return (
    <>
      <Component />
      {opened && (
        <HistoryModal opened={opened} close={close} summary={summary} />
      )}
    </>
  );
};

export default HistoryButton;
